import { OrderConfigsShippingResponse } from 'ncp-api-supporter';
import { i18n } from '@/main';

// ------- method -------

interface DaySelectBox {
  value: number;
  display: string;
}

const makeDayList = (length: number, suffix = ''): DaySelectBox[] => {
  return Array.from({ length }, (_, i): number => i + 1).map(
    (day): DaySelectBox => {
      return {
        value: day,
        display: `${day} ${suffix}`,
      };
    },
  );
};

// ------- initial data -------

export const DEFAULT_SHIPPING_CONFIG: OrderConfigsShippingResponse['value'] = {
  inputUrl: '',
  shippingEmptyAutoCancel: {
    use: false,
    cancelDays: 10,
  },
  shippingInputNotification: {
    use: false,
    reSendDays: 7,
  },
  recurringPaymentInputUrl: '',
};

export const GET_SHIPPING_CONFIG_PRESENTATIONAL_DATA = () => {
  return {
    // 배송지 미입력 주문 자동취소
    shippingEmptyAutoCancel: {
      options: {
        name: 'deliveryAddressNotEnteredAutoCancelOptions',
        data: [
          {
            id: 'auto-cancel-no-limit',
            display: i18n.t('LIMIT_N'),
            value: false,
          },
          {
            id: 'auto-cancel-pay-done',
            display: '결제(신청)완료',
            value: true,
          },
        ],
      },
      popupData: {
        id: 'DeliveryAddressNotEnteredPopup',
        hasConfirmBtn: false,
        hasCloseBtn: false,
        title: '배송지 미입력 주문 자동취소 안내',
      },
      dayList: makeDayList(30),
    },
    // 배송지 입력안내 알림
    shippingInputNotification: {
      options: {
        name: 'addressEnterNotificationOptions',
        data: [
          {
            id: 'use-resend-address-enter-notice',
            display: i18n.t('USABLE_Y'),
            value: true,
          },
          {
            id: 'unuse-resend-address-enter-notice',
            display: i18n.t('USABLE_N'),
            value: false,
          },
        ],
      },
      popupData: {
        id: 'addressEnterNotificationOptionsPopup',
        hasConfirmBtn: false,
        hasCloseBtn: false,
        title: '배송지 입력안내 알림 재발송 시점 안내',
      },
      dayList: makeDayList(30, '일'),
    },
  };
};
